"use strict";

exports.__esModule = true;
var _Dashboard = require("./Dashboard");
Object.keys(_Dashboard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Dashboard[key]) return;
  exports[key] = _Dashboard[key];
});